module.exports = __webpack_public_path__ + "img/go_circular_icon.32a6a721.png";